<template>

  <el-row>
    <el-row>
      <el-form :inline="true" :model="queryParam" class="demo-form-inline">
        <el-form-item>
          <el-select v-model="queryParam.status" clearable placeholder="线索状态">
            <el-option label="已处理" value="已处理"></el-option>
            <el-option label="未处理" value="未处理"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input v-model="queryParam.formViewName" placeholder="渠道来源"></el-input>
        </el-form-item>
        <el-form-item>

          <el-date-picker
              v-model="queryParam.createTime"
              clearable
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">搜索</el-button>
        </el-form-item>
        <el-form-item>
          <el-button @click="exportExcel">导出</el-button>
        </el-form-item>
      </el-form>
    </el-row>

    <el-row>
      <el-table :data="datas" border style="width: 100%" tooltip-effect="dark">
        <el-table-column label="询价人">
          <template scope="scope">
            <span style="margin-left: 10px">{{ scope.row['您的称呼'] }} </span>
            <br>
            <span style="margin-left: 10px">{{ getPhoneNumber(scope.row) }}</span>
          </template>
        </el-table-column>

        <el-table-column v-if="isAdmin" label="渠道来源">
          <template scope="scope">
            <span style="margin-left: 10px">{{ scope.row.formViewName }}</span>
          </template>
        </el-table-column>

        <el-table-column label="询价时间">
          <template scope="scope">
            <p class=" text-nowrap">{{ scope.row['提交时间'] | dateTimeFormat }}</p>
          </template>
        </el-table-column>

        <el-table-column label="线索状态">
          <template scope="scope">
            <p>
              <el-tag :type="scope.row.status==='已处理'?'success':'info'">
                {{ scope.row.status ? scope.row.status : '待处理' }}
              </el-tag>
            </p>
          </template>
        </el-table-column>
        <el-table-column v-if="isAdmin" label="备注" prop="note">
          <template scope="scope">
            <p class=" text-nowrap">{{ scope.row['remark'] }}
              <el-button @click="editNote(scope.row['_id'])" type="text">{{ !scope.row['remark'] ? '备注' : '修改' }}
              </el-button>
            </p>

          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="margin-left:0px" class="row basic-margin" @size-change="fn" @current-change="fn"
                     :current-page="currentPage" :page-size="10" layout="total, prev, pager, next, jumper"
                     :total="total">
      </el-pagination>
    </el-row>
  </el-row>

</template>

<script>

import BasicPager from '../../mixins/BasicPager'
import ClueModel from '../../framework/models/clueModel'
import Config from '@/framework/configs/Config'
import SearchAddressInput from '../oneBuyCar/children/SearchAddressInput'

export default {
  name: 'clue-group-purchase',
  components: { SearchAddressInput },
  extends: BasicPager,
  data: function () {
    return {
      isAdmin: false,
      queryParam: {
        status: null,
        formViewName: null,
        createTime: null
      },
      note: null,
      datas: [],
      currentPage: 1,
      total: 0,
      loading: false
    }
  },
  created: function () {
    let userInfo = JSON.parse(localStorage.userInfo)
    this.isAdmin = userInfo.loginPath !== 'channel'
    this.loadList(1)
    this.initData()
  },
  watch: {
    'queryParam.status': function () {
      this.currentPage = 1
      this.loadList()
    },
    'queryParam.createTime': function () {
      this.currentPage = 1
      this.loadList()
    }
  },
  methods: {
    exportExcel: function () {
      let userInfo = this.getLoginInfo()
      let loginPath = userInfo.loginPath
      let id = null
      if (userInfo.id) {
        id = userInfo.id
      } else if (userInfo.employeeId) {
        id = userInfo.employeeId
      }
      let url = Config.baseUrl + 'clue/exportFormDataExcel.action?token=' + userInfo.token + '&loginAccountId=' + id + '&loginPath=' + loginPath +
          '&groupName=团购惠'

      if (this.queryParam.status) {
        url += '&status=' + this.queryParam.status
      }
      if (this.queryParam.formViewName) {
        url += '&formViewName=' + this.queryParam.formViewName
      }

      if (this.queryParam.createTime && this.queryParam.createTime[0]) {
        url += '&startTime=' + this.queryParam.createTime[0].getTime() + '&endTime=' + this.queryParam.createTime[1].getTime()
      }

      window.open(url)
    },
    getPhoneNumber: function (row) {
      if (row['联系电话']) {
        return row['联系电话']
      }

      if (row['联系方式']) {
        return row['联系方式']
      }

      if (row['手机号码']) {
        return row['手机号码']
      }
    },
    editNote: function (clueId) {
      this.$prompt('请输入线索备注', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(({
        value
      }) => {
        if (!value) {
          this.$message({
            type: 'info',
            message: '备注不能为空！ '
          })

          return
        }

        let _this = this
        let params = {
          formDataId: clueId,
          remark: value
        }

        let listener = {
          success: function () {
            _this.$message({
              type: 'success',
              message: '操作成功！ '
            })
            _this.loadList()
          },
          error: function () {
            _this.$message({
              type: 'error',
              message: '操作失败！ '
            })
          }
        }

        ClueModel.updateRemark(this, params, listener)
      })
    },
    fn: function (d) {
      this.currentPage = d
      this.loadList()
    },
    search: function () {
      this.currentPage = 1
      this.loadList()
    },
    loadList: function () {
      let _this = this

      let params = {
        groupName: '团购惠',
        status: _this.queryParam.status,
        formViewName: _this.queryParam.formViewName,
        pageNum: _this.currentPage,
        pageSize: 10
      }

      if (this.queryParam.createTime && this.queryParam.createTime[0]) {
        params.startTime = this.queryParam.createTime[0].getTime()
        params.endTime = this.queryParam.createTime[1].getTime()
      }

      let listener = {
        success: function (dataInfo) {
          _this.datas = dataInfo.datas
          _this.loading = false
          _this.selectFormDataCounts()
        }
      }
      ClueModel.findFormDatas(_this, params, listener)
    },
    selectFormDataCounts: function () {
      let _this = this

      let params = {
        groupName: '团购惠',
        status: _this.queryParam.status,
        formViewName: _this.queryParam.formViewName
      }

      if (this.queryParam.createTime && this.queryParam.createTime[0]) {
        params.startTime = this.queryParam.createTime[0].getTime()
        params.endTime = this.queryParam.createTime[1].getTime()
      }

      let listener = {
        success: function (dataInfo) {
          _this.total = dataInfo.datas
        }
      }
      ClueModel.selectFormDataCounts(_this, params, listener)
    }
  }
}

</script>
